// extracted by mini-css-extract-plugin
export default {"main":"aae23e7e5f","tit":"bba689e289","maintitle":"_643d4a678d","ylw":"_934d89f710","white":"d9ecc8b0a0","mv_title":"_109a407efb","mv_nc":"dd17866205","mv_in":"df9a2b98e9"};